var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboardActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24C9.62666 24 7.30656 23.2962 5.33317 21.9776C3.35978 20.6591 1.82174 18.7849 0.913491 16.5922C0.00523901 14.3995 -0.232454 11.9867 0.230568 9.65892C0.693591 7.33115 1.83652 5.19295 3.51475 3.51472C5.19298 1.83649 7.33114 0.693605 9.65891 0.230582C11.9867 -0.232441 14.3995 0.00519943 16.5922 0.913451C18.7849 1.8217 20.6591 3.35978 21.9776 5.33317C23.2962 7.30656 24 9.62663 24 12C24 15.1826 22.7358 18.2349 20.4853 20.4853C18.2349 22.7357 15.1826 24 12 24ZM12 2.00001C10.0222 2.00001 8.08881 2.58649 6.44431 3.68531C4.79982 4.78412 3.51808 6.34591 2.76121 8.17317C2.00433 10.0004 1.80632 12.0111 2.19218 13.9509C2.57803 15.8907 3.53041 17.6725 4.92893 19.0711C6.32746 20.4696 8.1093 21.422 10.0491 21.8079C11.9889 22.1937 13.9996 21.9957 15.8269 21.2388C17.6541 20.4819 19.2159 19.2002 20.3147 17.5557C21.4135 15.9112 22 13.9778 22 12C22 9.34784 20.9464 6.8043 19.0711 4.92894C17.1957 3.05358 14.6522 2.00001 12 2.00001Z",
    fill: "url(#paint0_linear_3151_4893)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 20C10.4178 20 8.87104 19.5308 7.55545 18.6518C6.23986 17.7727 5.21448 16.5233 4.60898 15.0615C4.00348 13.5997 3.84504 11.9911 4.15372 10.4393C4.4624 8.88743 5.22435 7.46197 6.34317 6.34315C7.46199 5.22433 8.88745 4.4624 10.4393 4.15372C11.9911 3.84504 13.5997 4.00347 15.0615 4.60897C16.5233 5.21447 17.7727 6.23985 18.6518 7.55544C19.5308 8.87103 20 10.4178 20 12C20 14.1217 19.1572 16.1566 17.6569 17.6569C16.1566 19.1571 14.1218 20 12 20ZM12 6C10.8133 6 9.65329 6.3519 8.6666 7.01119C7.6799 7.67048 6.91088 8.60755 6.45676 9.70391C6.00263 10.8003 5.88382 12.0067 6.11533 13.1705C6.34684 14.3344 6.91824 15.4035 7.75736 16.2426C8.59647 17.0818 9.66561 17.6532 10.8295 17.8847C11.9934 18.1162 13.1998 17.9974 14.2961 17.5433C15.3925 17.0892 16.3296 16.3201 16.9889 15.3334C17.6481 14.3467 18 13.1867 18 12C18 10.4087 17.3679 8.88259 16.2426 7.75737C15.1174 6.63215 13.5913 6 12 6Z",
    fill: "url(#paint1_linear_3151_4893)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16C11.2089 16 10.4355 15.7654 9.77773 15.3259C9.11994 14.8864 8.60722 14.2616 8.30447 13.5307C8.00172 12.7998 7.92253 11.9956 8.07687 11.2196C8.23121 10.4437 8.61218 9.73098 9.17159 9.17157C9.731 8.61216 10.4437 8.2312 11.2196 8.07686C11.9956 7.92252 12.7998 8.00173 13.5307 8.30448C14.2616 8.60723 14.8864 9.11992 15.3259 9.77772C15.7654 10.4355 16 11.2089 16 12C16 13.0609 15.5786 14.0783 14.8285 14.8284C14.0783 15.5786 13.0609 16 12 16ZM12 10C11.6045 10 11.2178 10.1173 10.8889 10.3371C10.56 10.5568 10.3036 10.8692 10.1522 11.2346C10.0009 11.6001 9.96124 12.0022 10.0384 12.3902C10.1156 12.7781 10.3061 13.1345 10.5858 13.4142C10.8655 13.6939 11.2219 13.8844 11.6098 13.9616C11.9978 14.0387 12.3999 13.9991 12.7653 13.8478C13.1308 13.6964 13.4432 13.44 13.6629 13.1111C13.8827 12.7822 14 12.3956 14 12C14 11.4696 13.7893 10.9609 13.4142 10.5858C13.0391 10.2107 12.5305 10 12 10Z",
    fill: "url(#paint2_linear_3151_4893)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3151_4893",
    x1: 12,
    y1: 26.2222,
    x2: 12,
    y2: -3.11111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2177,
    stopColor: "#5C2562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656429,
    stopColor: "#9E2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D91B5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3151_4893",
    x1: 12,
    y1: 21.4815,
    x2: 12,
    y2: 1.92592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2177,
    stopColor: "#5C2562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656429,
    stopColor: "#9E2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D91B5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3151_4893",
    x1: 12,
    y1: 16.7407,
    x2: 12,
    y2: 6.96296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2177,
    stopColor: "#5C2562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656429,
    stopColor: "#9E2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D91B5D"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardActive);
export default __webpack_public_path__ + "static/media/dashboard-active.62fc89bd49f4c72d4626b1e6843db1f0.svg";
export { ForwardRef as ReactComponent };